import React from 'react';
import { Typography,Divider } from 'antd';
import { profileconfig } from '../../configurations/profileconfig';
import { useEffect } from 'react';
const PersonalDetails = (props)=>{
  const {Text,Title,Link} = Typography
    return(
        profileconfig?.[props?.userType]?.[props?.tabNumber]?.fields.map((item)=>{
            if(item.type == "Text" || item.type == "Phone" || item.type == "Number" || item.type == "Select"){
                return props?.data?.[item?.name] != undefined? <div className={`userRegistration ${props?.objectionKey.includes(item?.label2) == true ? 'userRegistrationWarning' : ''}`}><Text className='profileTitle' level={5}>{item.label}:</Text> <Text>{props?.data?.[item?.name]}</Text>
                </div>:null
            }
            if(item.type == 'Upload'){
                return props?.data?.[item?.name] != undefined? <div className={`userRegistration ${props?.objectionKey.includes(item?.label2) == true ? 'userRegistrationWarning' : ''}`}><Text className='profileTitle'  level={5}>{item.label}:</Text> <Link href={props?.data?.[item?.name]?.url} target='_blank'>{props?.data?.[item?.name]?.name}</Link>
                </div>:null
            }
            
        })
    )

}

export default PersonalDetails